import { upsertAppointment } from '../../../api/appointments';

/**
 * Archive a live company appointment in Postgres (status cancelled / no show).
 */
export async function archiveCompanyAppointment(_db, companyId, appointment, options = {}) {
  const appointmentId = appointment?.id;
  if (!companyId || !appointmentId) {
    throw new Error('Missing companyId or appointment id');
  }

  const {
    status = 'cancelled',
    cancelReason,
    updatedBy = 'employee',
    updatedByName = null,
    updatedByUid = null,
    lastAction = status,
    archivedBy,
  } = options;

  const normalizedStatus = String(status || 'cancelled').trim().toLowerCase();
  if (normalizedStatus === 'cancelled' && !cancelReason?.trim()) {
    throw new Error('Cancellation reason is required');
  }

  const now = new Date().toISOString();
  await upsertAppointment({
    companyId,
    id: appointmentId,
    appointment: {
      status: normalizedStatus,
      archived: true,
      archivedAt: now,
      archivedBy: archivedBy || updatedByUid || updatedBy,
      cancelReason: cancelReason?.trim() || undefined,
      updatedAt: now,
      lastUpdated: now,
      updatedBy,
      updatedByName,
      updatedByUid,
      lastAction,
    },
  });
}
